import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function Signup() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await register(form.email, form.password, form.name);
            toast.success("Account created — let's set up your voice.");
            navigate("/onboarding", { replace: true });
        } catch (e2) {
            setErr(formatApiError(e2));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-6 py-16">
                <div className="lk-label">Sprint 1 — early access</div>
                <h1 className="font-heading text-4xl mt-2 tracking-tight">Create your account</h1>
                <p className="text-[var(--lk-muted)] mt-3 text-sm">Free during the POC. No credit card. Just email + password.</p>

                <form onSubmit={submit} className="mt-8 space-y-4">
                    <div>
                        <label className="lk-label block mb-2">Name</label>
                        <input
                            required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                            className="w-full lk-border lk-surface-2 rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lk-primary)]"
                            data-testid="signup-name-input"
                            placeholder="Ada Lovelace"
                        />
                    </div>
                    <div>
                        <label className="lk-label block mb-2">Email</label>
                        <input
                            type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="w-full lk-border lk-surface-2 rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lk-primary)]"
                            data-testid="signup-email-input"
                            placeholder="you@company.com"
                        />
                    </div>
                    <div>
                        <label className="lk-label block mb-2">Password</label>
                        <input
                            type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                            className="w-full lk-border lk-surface-2 rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lk-primary)]"
                            data-testid="signup-password-input"
                            placeholder="At least 6 characters"
                        />
                    </div>
                    {err ? <div className="text-sm text-red-400" data-testid="signup-error">{err}</div> : null}
                    <button type="submit" disabled={loading} className="lk-btn-primary rounded-full px-6 py-3 w-full disabled:opacity-50" data-testid="signup-submit-btn">
                        {loading ? "Creating..." : "Create account"}
                    </button>
                </form>

                <div className="mt-6 text-sm text-[var(--lk-muted)]">
                    Already have an account? <Link to="/login" className="text-[var(--lk-primary)] underline" data-testid="signup-to-login">Log in</Link>
                </div>
            </div>
        </div>
    );
}
